// @ts-nocheck
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import ExpandPanel from '../../common/ExpandPanel';
import icons from '../../../constants/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { scopes as tableScopes } from '../../../constants/scopes';
import { useTranslation } from 'react-i18next';
import { CommaNumber_WithDecimal } from '../../../util/formatter';

export interface WarningMaxKeysProps {
  globalTransactionLimit: any;
  currentGlobalTransactionAmount: any;
  companyId: any;
  companyName?: string;
}

export default function WarningMaxKeys({
  globalTransactionLimit,
  currentGlobalTransactionAmount,
  companyId,
  companyName,
}: WarningMaxKeysProps) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <ExpandPanel className={`alert alert-danger ${isOpen ? '' : 'collapsed'}`}>
      <header
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <h2 className="heading-with-icon">
          <span className="icon-wrapper warning-icon me-3">
            <FontAwesomeIcon icon={icons.ARE_YOU_SURE} />
          </span>
          {companyName
            ? t('Warning - balance of allocated keys exceeded for {company}', {
                company: companyName,
              })
            : t(
                'Warning - balance of allocated keys exceeded for this company'
              )}
          <span className="ui-icon">
            <FontAwesomeIcon icon={icons.ACCORDIAN_CLOSED} />
          </span>
        </h2>
      </header>
      <div className="content clearfix">
        <div className="container-fluid">
          <div className="row">
            <label className="col-sm-3 col-form-label">
              {t('Maximum balance of all allocated keys')}
            </label>
            <div className="col-sm-3 ps-0 pe-0 pe-md-4 mb-2 mb-md-0">
              <NavLink
                to={`/company/${companyId}`}
                className="form-control-static px-3 py-2 flex  h-100 align-items-center"
                title={t('Company settings')}
              >
                <div className="width-100 num">
                  {CommaNumber_WithDecimal(globalTransactionLimit, undefined)}
                </div>
                <div className="me-2">
                  <FontAwesomeIcon icon={icons.SETTINGS} />
                </div>
              </NavLink>
            </div>
            <label className="col-sm-3 col-form-label">
              {t('Balance including this request')}
            </label>
            <div className="col-sm-3 ps-0 pe-0">
              <NavLink
                to={`/keys/game?${tableScopes.COMPANY}=${companyId}`}
                className="form-control-static px-3 py-2 flex h-100 align-items-center"
                title={t('View keys for this company')}
              >
                <div className="width-100 num">
                  {CommaNumber_WithDecimal(
                    currentGlobalTransactionAmount,
                    undefined
                  )}
                </div>
                <div className="me-2">
                  <FontAwesomeIcon icon={icons.LINK_INTERNAL} />
                </div>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </ExpandPanel>
  );
}
